import { Injectable, Inject } from '@angular/core';
import {
  Config,
  ConfigOptions,
  FRAuth,
  FRStep,
  FRLoginSuccess,
  FRLoginFailure,
} from '@forgerock/javascript-sdk/lib-esm';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { LOGIN_REALM } from '@usana/ux/sso-auth';

/**
 * mostly for abstraction purposes
 */
@Injectable({
  providedIn: 'root',
})
export class FrSdkService {
  private currentConfigOptions: ConfigOptions;

  constructor(private readonly httpClient: HttpClient, @Inject(LOGIN_REALM) private readonly defaultRealm: string) {
    // we don't care about clientId, but FR does so we gotta
    this.configure({
      serverConfig: {
        baseUrl: environment.app.frogBaseUrl,
        timeout: 90000,
      },
      realmPath: defaultRealm,
    });

    this.patchConfigOptions({
      clientId: environment.app.frConfig.frogClientId,
      redirectUri: environment.app.frConfig.frogRedirectUri,
      scope: environment.app.frConfig.frogScope,
      tree: environment.app.frConfig.frogTree,
    });
  }

  next(step: FRStep): Promise<FRStep | FRLoginSuccess | FRLoginFailure> {
    return FRAuth.next(step);
  }

  currentRealm(): string {
    return this.currentConfigOptions.realmPath;
  }

  patchConfigOptions(options: ConfigOptions): void {
    if ((options.serverConfig && options.serverConfig.baseUrl) || options.tokenStore) {
      throw new Error('unsupported fr config change');
    }
    const newOptions = Object.assign(this.currentConfigOptions, options);
    this.configure(newOptions);
  }

  private configure(options: ConfigOptions): void {
    Config.set(options);
    // update our current config for any future patches
    this.currentConfigOptions = options;
  }
}
